import React, { useContext } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import { AuthContext } from '../../components/AuthContext';
import { FaBuilding, FaUsers, FaMapMarkerAlt, FaTags, FaCopyright, FaServer, FaIndustry, FaUserTie, FaDatabase, FaHeadset } from 'react-icons/fa';
import DashboardHome from './DashboardHome';
import CompanyManagement from './CompanyManagement';
import CompanyHeadManagement from './CompanyHeadManagement';
import AdminManagement from './AdminManagement';
import SupportManagement from './SupportManagement';
import LocationManagement from './LocationManagement';
import CategoryManagement from './CategoryManagement';
import BrandManagement from './BrandManagement';
import ServerLogs from './ServerLogs';
import FirmManagement from './FirmManagement';
import DataExport from './DataExport';

const SuperAdminDashboard = () => {
  const { logout } = useContext(AuthContext);

  const sidebarLinks = [
    { to: "/super-admin/dashboard", icon: FaBuilding, label: "Dashboard", component: <DashboardHome /> },
    { to: "/super-admin/firms", icon: FaIndustry, label: "Firm Management", component: <FirmManagement /> },
    { to: "/super-admin/companies", icon: FaBuilding, label: "Company Management", component: <CompanyManagement /> },
    { to: "/super-admin/company-heads", icon: FaUsers, label: "Company Head Management", component: <CompanyHeadManagement /> },
    { to: "/super-admin/admins", icon: FaUserTie, label: "Admin Management", component: <AdminManagement /> },
    { to: "/super-admin/locations", icon: FaMapMarkerAlt, label: "Locations Management", component: <LocationManagement /> },
    { to: "/super-admin/categories", icon: FaTags, label: "Category Management", component: <CategoryManagement /> },
    { to: "/super-admin/brands", icon: FaCopyright, label: "Brand Management", component: <BrandManagement /> },
    { to: "/super-admin/logs", icon: FaServer, label: "Server Logs", component: <ServerLogs /> },
    { to: "/super-admin/data-export", icon: FaDatabase, label: "Data Export", component: <DataExport /> },
    { to: "/super-admin/support", icon: FaHeadset, label: "Support Team", component: <SupportManagement /> },
  ];

  const currentPath = window.location.pathname;
  const matchingLink = sidebarLinks.find(link => link.to === currentPath);

  return (
    <DashboardLayout 
      title="Super Admin" 
      sidebarLinks={sidebarLinks}
      onLogout={() => {
        logout();
        window.location.href = "/";
      }}
    >
      {matchingLink && matchingLink.component}
    </DashboardLayout>
  );
};

export default SuperAdminDashboard;